module.exports = __webpack_public_path__ + "img/logotipo.fa2a2a52.svg";